module.exports = __webpack_public_path__ + "static/media/processing.587fb040.svg";